export default "__VITE_ASSET__as3WX6zh__"